module.exports = __webpack_public_path__ + "static/media/rail.8899ea31.jpeg";